import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { getAllReview, getFilterReviewTask } from '../Common/AllTaskSlice';
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap';
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import * as Icon from "react-bootstrap-icons";
// import { FilterReviewModel } from './Model/FilterReviewModel';
import { useLocation } from 'react-router-dom';
import Pagination from '../Common/Pagination';
import { getAllReview } from './TLSlice';
import { TlReviewModel } from './Model/TlReviewModel';
import EmployeeReviewFilter from '../Common/Filter/EmployeeReviewFilter';
import useGetEmployees from '../Common/ReuseApi/useGetEmployees';
import useGetDepartments from '../Common/ReuseApi/useGetDepartments';
import { useProjectList } from '../Common/ReuseApi/useProjectList ';
import useGetSubDepartments from '../Common/ReuseApi/useGetSubDepartments';

const TlReview = () => {

    const dispatch = useDispatch()

    const location = useLocation();
    const routeName = location.pathname

    const loginUserData = useSelector((state) => state.loginData.userData)
    const reviewData = useSelector(state => state?.TLAssignedData?.TlAllEmpTaskReview)
    const filterAllTasks = useSelector((state) => state?.AllTasks?.AllFilterTasksData);

    const copiedData = reviewData !== undefined && reviewData !== null && reviewData.length > 0 ?
        JSON.parse(JSON.stringify(reviewData)) :
        [];

    const [project, setProject] = useState(null);
    const [department, setDepartment] = useState(null);
    const [subDepartment, setSubDepartment] = useState(null);
    const [resource, setResource] = useState(null);
    const [reviewDate, setReviewDate] = useState("");
    const [idcMin, setIdcMin] = useState(null);
    const [idcMax, setIdcMax] = useState(null);
    const [qwdMin, setQwdMin] = useState(null);
    const [qwdMax, setQwdMax] = useState(null);

    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [showFilter, setShowFilter] = useState(false)

    const { employeeOptions } = useGetEmployees();
    const { allDepartmentOptionsById } = useGetDepartments();
    const { subDeptOptions } = useGetSubDepartments(department?.value);
    const { projectOptions, departmentOptions } = useProjectList(project?.value);

    useEffect(() => {
        getReviewData()
    }, [currentPage, docsPerPage, routeName])


    const getReviewData = (page = currentPage) => {
        const payload = {
            empId: loginUserData?.empId,
            assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            subDepartmentId: subDepartment?.value,
            department_id: department?.value,
            taskName: "",
            projectName: project?.label || "",
            resource_id: resource?.value || "",
            idc: idcMin?.value || "",
            qwd: qwdMin?.value || "",
            slippage: "",
            efficiency: "",
            reviewDate: reviewDate || "",
            resourceType: loginUserData?.resourceType,
            documentsPerPage: docsPerPage,
            page: page
        }
        dispatch(getAllReview(payload))
    }


    // for show data not found
    const [showNoDataFound, setShowNoDataFound] = useState(false);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);

    };

    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1)
        setDocsPerPage(docsPageProp);
    }

    const handleSearch = () => {
        setCurrentPage(1)
        getReviewData(1)
    }

    const handleClear = () => {
        setProject(null)
        setDepartment(null)
        setSubDepartment(null)
        setResource(null)
        setReviewDate("")
        setIdcMin(null)
        setIdcMax(null)
        setQwdMin(null)
        setQwdMax(null)
        setCurrentPage(1)
        dispatch(getAllReview({
            empId: loginUserData?.empId,
            assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            departments: [],
            subDepartmentName: "",
            taskName: "",
            projectName: "",
            resource_id: "",
            idc: "",
            qwd: "",
            slippage: "",
            efficiency: "",
            reviewDate: "",
            resourceType: loginUserData?.resourceType,
            documentsPerPage: docsPerPage,
            page: currentPage
        }))
    }

    return (
        <>
            <div className='outletPadding' data-aos="fade-up">
                <Container>
                    <ToastContainer />
                    <EmployeeReviewFilter
                        projectOptions={projectOptions}
                        departmentOptions={allDepartmentOptionsById}
                        subDeptOptions={subDeptOptions}
                        employeeOptions={employeeOptions}
                        idcOptions={[
                            { label: "1", value: "1" },
                            { label: "2", value: "2" },
                            { label: "3", value: "3" },
                            { label: "4", value: "4" },
                            { label: "5", value: "5" },
                            { label: "6", value: "6" },
                            { label: "7", value: "7" },
                            { label: "8", value: "8" },
                            { label: "9", value: "9" },
                            { label: "10", value: "10" },
                        ]}

                        project={project}
                        setProject={setProject}
                        department={department}
                        setDepartment={setDepartment}
                        subDepartment={subDepartment}
                        setSubDepartment={setSubDepartment}
                        resource={resource}
                        setResource={setResource}
                        reviewDate={reviewDate}
                        setReviewDate={setReviewDate}
                        idcMin={idcMin}
                        setIdcMin={setIdcMin}
                        idcMax={idcMax}
                        setIdcMax={setIdcMax}
                        qwdMin={qwdMin}
                        setQwdMin={setQwdMin}
                        qwdMax={qwdMax}
                        setQwdMax={setQwdMax}
                        role={loginUserData?.resourceType}
                        onSubmit={handleSearch}
                        onClear={handleClear}
                    />
                    <div className='outer-wrapper mx-auto'>
                        <div className='table-wrapper'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Sr.No</th>
                                        <th>Project Name</th>
                                        <th className='taskwidth'>Task Name</th>
                                        <th className='assignwidth'>Resource Name</th>
                                        <th>Department</th>
                                        <th>IDC</th>
                                        <th>QWD</th>
                                        <th>Slippage</th>
                                        <th>Efficiency</th>
                                        <th>Review Date</th>
                                    </tr>
                                </thead>
                                {filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                                    <tbody>
                                        {
                                            reviewData?.data !== null &&
                                                reviewData?.data !== undefined &&
                                                reviewData?.data?.length > 0 ? (
                                                (filterAllTasks?.data?.length > 0
                                                    ? filterAllTasks?.data
                                                    : reviewData?.data
                                                ).map((itm, index) => {
                                                    const { taskName, reviewDate, taskDepartmentName, projectName, resourceName,
                                                        idc, qwd, slippage, efficiency } = itm
                                                    return (
                                                        <tr key={Math.random() * 999999999}>
                                                            <td> {currentPage !== 1 ? (
                                                                <>
                                                                    {index + 1 + docsPerPage * (currentPage - 1)}
                                                                </>
                                                            ) : (
                                                                <>{index + 1}</>
                                                            )}</td>
                                                            <td>{projectName}</td>
                                                            <td style={{ flexWrap: "wrap" }}>{taskName}</td>
                                                            <td>{resourceName}</td>

                                                            {/* <td>{resourceName}</td> */}
                                                            <td>{taskDepartmentName}</td>
                                                            <td>{idc !== null && idc !== undefined ? idc.toFixed(2) : 0}</td>
                                                            <td>{qwd !== null && qwd !== undefined ? qwd.toFixed(2) : 0}</td>
                                                            <td>{slippage !== undefined && slippage !== null ? slippage.toFixed(2) : 0}</td>
                                                            <td>{efficiency !== undefined && efficiency !== null ? efficiency.toFixed(2) : 0}</td>
                                                            <td>{moment(reviewDate).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="18" className="text-center">No data available</td>
                                                </tr>
                                            )}
                                    </tbody>
                                )
                                    :
                                    <tr>
                                        <td colSpan="16" className="text-center">No Task Available</td>
                                    </tr>
                                }
                            </table>
                        </div>
                    </div>

                </Container>

                {
                    reviewData?.data !== null || reviewData?.data?.length > 0 ?
                        <div className="pagination-wrapper p-0">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={filterAllTasks?.data?.length > 0 ? filterAllTasks?.noOfPages : reviewData?.noOfPages}
                                onPageChange={handlePageChange}
                                onDocsPerPage={handleDocsPerPage}
                                docsPerPage={docsPerPage}
                            />
                        </div>
                        : ''
                }
            </div>
        </>
    )
}

export default TlReview